<div class="plants-details-container" fxLayout="row" fxLayoutAlign="space-between start">
    <div fxLayout="row" fxLayoutGap="20px" fxFlex="75">
        <div fxLayout="column" fxLayoutGap="20px" fxFlex="70">
            <div fxLayout="column" class="block" fxLayoutGap="2px">
                <div *ngIf="isNotRepresentative" class="txt-s-16-7 mb-12">{{ 'Injected energy withdrawal'|i18n }}</div>
                <div fxLayout="row" fxLayoutGap="30px">
                    <div *ngIf="isNotRepresentative" fxLayout="column" fxLayoutAlign="center start">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="14px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4">{{ 'Injected energy'|i18n }}</div>
                            <app-icon icon-color-h name="fas-info-circle"
                                      [title]="'It is the electricity actually fed into the grid plus conventional loss coefficients, as provided for in Article 76 of ARERA\'s TIS, to take into account electricity losses on transmission and distribution grids and used for energy retirement purposes.'|i18n">
                            </app-icon>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="14px">
                            <div class="txt-h-16-7">{{ isDefined(plantsPod.injected_energy) ? (plantsPod.injected_energy|niceValue: 'kWh') : '- kWh' }}</div>
                        </div>
                    </div>
                    <div fxLayout="column" *ngIf="isNotRepresentative" fxLayoutAlign="center start">
                        <div fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="14px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4">{{ 'Amount'|i18n }}</div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="14px">
                            <div class="txt-h-16-7">{{ isDefined(plantsPod.rei) ? (plantsPod.rei|niceValue: '€':2: plantsPod.rei < 0) : '-' }}</div>
                        </div>
                    </div>
                </div>
                <!--TODO show when BE manage insert GSE data-->
                <!--                <div fxLayout="row" fxLayoutAlign="center center" *ngIf="isCommunityPv" class="mt-15">
                                    <button app-ghost-button (click)="onClickInsertBilledData()">
                                        <app-icon name="fal-pencil-alt" class="mr-16"></app-icon>
                                        {{'Bill data'|i18n}}
                                    </button>
                                </div>-->
            </div>
            <div fxLayout="column" fxLayoutGap="12px" class="block">
                <div class="txt-s-16-7" [innerHTML]="'Generated TIP and {0}'|i18n:CACV_STRING"></div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="50px">
                    <div fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4">{{ 'Effective injected energy'|i18n }}</div>
                            <app-icon icon-color-h name="fas-info-circle"
                                      [title]="'Electricity actually fed in from feed-in points without the addition of conventional loss coefficients and used to determine shared energy.'|i18n">
                            </app-icon>
                        </div>
                        <div class="txt-h-16-7">
                            {{ isDefined(plantsPod.effective_injected_energy) ? (plantsPod.effective_injected_energy|niceValue: 'kWh') : '- kWh' }}
                        </div>
                    </div>
                    <div fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4">{{ 'Shared energy'|i18n }}</div>
                        </div>
                        <div class="txt-h-16-7">
                            {{ isDefined(plantsPod.shared_energy) ? (plantsPod.shared_energy|niceValue: 'kWh') : '- kWh' }}
                        </div>
                    </div>
                    <div fxLayout="column" *ngIf="nonIncentivizedPlants">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4">{{ 'Incentive shared energy'|i18n }}</div>
                        </div>
                        <div class="txt-h-16-7">
                            {{ isDefined(plantsPod.incentive_shared_energy) ? (plantsPod.incentive_shared_energy|niceValue: 'kWh') : '- kWh' }}
                        </div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4" [innerHTML]="'Gross {0}'|i18n:CACV_STRING"></div>
                        </div>
                        <div class="txt-h-16-7">
                            {{ isDefined(plantsPod.gross_c_acv) ? (plantsPod.gross_c_acv|niceValue: '€':2: plantsPod.gross_c_acv < 0) : '-' }}
                        </div>
                    </div>
                    <div fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4" [innerHTML]="'Net {0}'|i18n:CACV_STRING"></div>
                        </div>
                        <div class="txt-h-16-7">
                            {{ isDefined(plantsPod.net_c_acv) ? (plantsPod.net_c_acv|niceValue: '€':2: plantsPod.net_c_acv < 0) : '-' }}
                        </div>
                    </div>
                    <div fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4">{{ 'Gross TIP'|i18n }}</div>
                        </div>
                        <div class="txt-h-16-7">
                            {{ grossTip }}
                        </div>
                    </div>
                    <div fxLayout="column">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <app-icon icon-color-s name="fal-piggy-bank"></app-icon>
                            <div class="txt-h-14-4">{{ 'Net TIP'|i18n }}</div>
                        </div>
                        <div class="txt-h-16-7">
                            {{ netTip }}
                        </div>
                    </div>
                </div>
                <div *ngIf="capitalGrantUse" class="txt-acc-14-4" fxLayout="row" fxLayoutAlign="start center">
                    <app-icon name="fal-check-circle"></app-icon>
                    {{ 'Uses capital grant'|i18n }}
                </div>
            </div>
            <div *ngIf="!plantsPod.producer" fxLayout="row" fxLayoutAlign="space-between start" class="block">
                <div class="txt-s-16-7">{{ 'Physical self-consumption'|i18n }}</div>
                <div fxLayout="column">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-h-14-4">
                        <app-icon name="fal-piggy-bank"></app-icon>
                        <div>{{ 'Physical self-consumed energy'|i18n }}</div>
                    </div>
                    <div class="txt-h-16-7">{{ isDefined(plantsPod.self_consumed_energy) ? (plantsPod.self_consumed_energy|niceValue: 'kWh') : '- kWh' }}</div>
                </div>

                <div *ngIf="isDefined(plantsPod.seu) && plantsPod.seu" fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="20px">
                    <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="30px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="txt-acc-14-4">
                            <app-icon name="fal-check-circle"></app-icon>
                            <div>SEU</div>
                        </div>
                        <div fxLayout="column">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                                <app-icon name="fal-piggy-bank"></app-icon>
                                <div>{{ 'Amount'|i18n }}</div>
                            </div>
                            <div class="txt-h-16-7">{{ isDefined(plantsPod.self_consumed_energy_valorization) ? (plantsPod.self_consumed_energy_valorization|niceValue: '€') : '- €' }}</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <div class="txt-s-14-7">{{ 'Minimum SEU price'|i18n }}</div>
                        <div class="txt-s-14-4">{{ economicsConfig.self_consumed_energy_default_rate|niceValue:'€/MWh' }}</div>
                        <app-icon name="fas-info-circle" [title]="'Amount defined by the manager'|i18n"></app-icon>
                    </div>
                </div>

                <div *ngIf="!isDefined(plantsPod.seu) || !plantsPod.seu" fxFlex="50"></div>

            </div>
        </div>

        <div fxLayout="column" fxLayoutGap="20px" fxFlex="30">
            <div fxLayout="column" class="block" fxLayoutGap="25px">
                <ng-container *ngIf="!isCommunityPlant">
                    <div fxLayout="column" fxLayoutGap="5px">
                        <span class="txt-s-16-7" [innerHTML]="'Plant TIP and {0}'|i18n:CACV_STRING"></span>
                        <span class="txt-h-14-7">{{ 'Plant TIP'|i18n }}</span>
                        <div class="mt-6 txt-h-14-4">
                            {{ plantTip }}
                        </div>
                        <div class="mt-8 txt-s-14-4">
                            {{ utilitiesAbsorptionFee }}
                        </div>
                        <span class="txt-h-14-7 mt-30" [innerHTML]="'Plant {0} '|i18n:CACV_STRING"></span>
                        <div class="mt-6 txt-h-14-4">{{ plantCacv }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="txt-s-16-7">
                            {{ 'Plant total net amount'|i18n }}
                        </div>
                        <div class="txt-h-26-7">
                            {{ (plantsPod.net_revenue || 0)|niceValue:'€':2 : plantsPod.net_revenue < 0 }}
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="isCommunityPlant"
                     fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px"
                     class="mt-20">
                    <ng-container *ngIf="!isDefined(plantsPod.rei_redistribution_status)">
                        <app-icon icon-color-w name="fas-exclamation-triangle"></app-icon>
                        <span class="txt-s-14-4">{{ 'Withdrawal destination not configured'|i18n }}</span>
                    </ng-container>
                    <ng-container
                            *ngIf="isDefined(plantsPod.rei_redistribution_status) && plantsPod.rei_redistribution_status">
                        <app-icon name="fal-check-circle" class="monitored"></app-icon>
                        <span class="txt-s-14-4 monitored">{{ 'Uses withdrawal by allocation'|i18n }}</span>
                    </ng-container>
                    <ng-container
                            *ngIf="isDefined(plantsPod.rei_redistribution_status) && !plantsPod.rei_redistribution_status">
                        <app-icon name="fal-times-circle" class="not-monitored"></app-icon>
                        <span class="txt-s-14-4">{{ 'Does not use withdrawal by allocation'|i18n }}</span>
                    </ng-container>
                </div>
                <div class="mt-20" fxLayoutAlign="center center">
                    <button app-primary-button *ngIf="enableTipConfig"
                            [disabled]="missingCosts(economicsPlantsResponse,strategy) || (!isCommunityPlant && !generatesTip)"
                            (click)="openConfigureDialog()">
                        <app-icon name="fal-pencil-alt" class="font-size-14"></app-icon>
                        <span>{{ 'Configure this plant'|i18n }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center start" fxFlex="25">
        <div fxLayout="column" fxLayoutGap="30px" fxFlex="80">
            <div *ngIf="!isCommunityPlant">
                <button app-small-ghost-button
                        (click)="onClickGoToMembers()">
                    <app-icon name="fal-user"></app-icon>
                    {{ plantsPod.member.personal_data.first_name + ' ' + plantsPod.member.personal_data.last_name }}
                </button>
            </div>
            <ng-container *ngFor="let p of plantsPod.plants">
                <ng-container *ngIf="p.entity">
                    <div fxLayout="column" fxLayoutGap="5px">
                        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center"
                             [ngClass]="hasFutureActivation(p.activation_date) ? 'disabled-label' : ''">
                            <div>
                                <app-icon icon-color-s *ngIf="p.entity|entityIcon; let icon" [name]="icon"
                                          class="mt-4 mr-10"></app-icon>
                                <span class="txt-h-16-5">{{ p.entity.name }}</span>
                            </div>
                            <div>
                                <span class="txt-s-16-4">{{ p.entity|entityType|i18n }}</span>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center"
                             [ngClass]="hasFutureActivation(p.activation_date) ? 'disabled-label' : ''">
                            <div fxLayout="column">
                                <div fxLayout="row">
                                    <ng-container *ngIf="isDefined(p.activation_date)">
                                        <app-icon name="fal-play-circle" class="txt-h-16-7 mr-10"></app-icon>
                                        <span class="txt-h-16-4">{{ p.activation_date|i18nDate }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="!isDefined(p.activation_date)">
                                        <span class="txt-h-16-4">-</span>
                                    </ng-container>
                                </div>
                                <div *ngIf="p.incentive_mode !== PlantIncentiveMode.NO_INCENTIVE" class="monitored">
                                    <app-icon name="fal-check-circle"></app-icon>
                                    {{ 'Generates TIP'|i18n }}
                                </div>
                                <div *ngIf="p.incentive_mode === PlantIncentiveMode.NO_INCENTIVE" class="not-monitored">
                                    <app-icon name="fal-times-circle"></app-icon>
                                    {{ 'Doesn\'t generate TIP'|i18n }}
                                </div>
                            </div>
                            <button app-ghost-button (click)="onClickGoToPlant(p.entity.id)">
                                {{ 'Resource'|i18n }}
                                <app-icon name="fal-arrow-right" class="mr-0 right-icon"></app-icon>
                            </button>
                        </div>
                    </div>

                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #configureTipQuote let-data let-close="close">
    <div class="dialog">
        <app-set-tip [year]="selectedYear"
                     [massiveConfig]="false"
                     [tipConfigs]="plantsPod.tip_configs"
                     [TSI]="plantsPod.plants_payable_tariff"
                     [ECNE]="plantsPod.incentivized_shared_energy_non_surplus"
                     [incentiveSharedEnergy]="plantsPod.gse ? plantsPod.incentive_shared_energy : plantsPod.estimated_incentive_shared_energy"
                     [grossTip]="plantsPod.gross_tip"
                     [netTip]="plantsPod.net_tip"
                     [capitalGrantUse]="capitalGrantUse"
                     [nonSurplusTip]="plantsPod.non_surplus_tip"
                     (tipResponse)="data.tipResponse = $event"
                     (valid)="data.valid = $event">
        </app-set-tip>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" class="mt-24">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="48px">
            <button app-ghost-button (click)="close(false)">
                {{ 'Cancel'|i18n }}
            </button>
            <button app-primary-button [disabled]="!data.valid || !data.tipResponse"
                    (click)="close(data.tipResponse)">
                {{ 'Confirm'|i18n }}
            </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
            <span class="txt-s-14-4">{{ 'Apply only to the facility in question.'|i18n }}</span>
        </div>
    </div>
</ng-template>

<ng-template #configureRei let-data let-close="close">
    <div class="dialog">
        <app-set-rei [inputRei]="plantsPod.rei_redistribution_status"
                     [year]="selectedYear"
                     [massiveConfig]="false"
                     (reiResponse)="data.reiResponse = $event"
                     (valid)="data.valid = $event">
        </app-set-rei>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" class="mt-24">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="48px">
            <button app-ghost-button (click)="close(undefined)">
                {{ 'Cancel'|i18n }}
            </button>
            <button app-primary-button [disabled]="!data.valid"
                    (click)="close(data.reiResponse)">
                {{ 'Confirm'|i18n }}
            </button>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
            <span class="txt-s-14-4">{{ 'Apply only to the facility in question.'|i18n }}</span>
        </div>
    </div>
</ng-template>

<ng-template #selectDate let-data let-close="close">
    <div class="dialog app-dialog-background">
        <app-ec-select-date [summaryConsolidations]="summaryConsolidations"
                            [dateSelection]="currentDateSelection"
                            [content]="currentContent"
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                            (values)="data.values = $event"
                            (valid)="data.valid = $event">
        </app-ec-select-date>
    </div>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-24" fxLayoutGap="20px">
        <button app-ghost-button [mat-dialog-close]="false">
            {{ 'Not now'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.valid || !data.values"
                (click)="close(data.values)">
            {{ 'Configure'|i18n }}
            <app-icon class="ml-10" name="fal-arrow-right"></app-icon>
        </button>
    </div>
</ng-template>

<ng-template #setBilledData let-data let-close="close">
    <div class="dialog">
        <app-set-billed-data [date]="date"
                             (values)="data.values = $event"
                             (valid)="data.valid = $event">
        </app-set-billed-data>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="48px" class="mt-24">
        <button app-ghost-button (click)="close(undefined)">
            {{ 'Cancel'|i18n }}
        </button>
        <button app-primary-button [disabled]="!data.valid || !data.values"
                (click)="close(data.values)">
            {{ 'Confirm'|i18n }}
        </button>
    </div>
</ng-template>
